import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName, getValue } from "../../../../components/Converter";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import { ImperialUnits, MetricUnits } from "../../../../components/Math/Units/AllUnits";
import KilopoundPerSquareInch from "../../../../components/Math/Units/Imperial/KilopoundPerSquareInch";
import Megapascal from "../../../../components/Math/Units/Metric/Megapascal";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../i18n";
import {
  selectTwentyEightDayGroutStrength,
  setTwentyEightDayGroutStrength,
} from "../../../../store/slices/aashtoSlice";
import { selectIsImperial, selectIsMetric } from "../../../../store/slices/settingsSlice";

function TwentyEightDayGroutStrength() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const twentyEightDayGroutStrength = useSelector(selectTwentyEightDayGroutStrength);

  const isImperial = useSelector(selectIsImperial);
  const isMetric = useSelector(selectIsMetric);

  let unitType = isMetric
    ? MetricUnits.Megapascal
    : isImperial
      ? ImperialUnits.KilopoundPerSquareInch
      : null;

  const metricUnit = <Megapascal />;
  const imperialUnit = <KilopoundPerSquareInch />;

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Choose 28-day grout strength")}</p>}
      indicesValue={
        <span>
          f<sup>'</sup>
          <sub>c</sub>
        </span>
      }
      inputValue={
        <NumberFormat
          className={getClassName(twentyEightDayGroutStrength.current)}
          value={getValue(twentyEightDayGroutStrength.current)}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          decimalScale={3}
          displayType="input"
          type="text"
          onValueChange={(values, sourceInfo) => {
            if (sourceInfo?.event?._reactName === "onChange") {
              dispatch(
                setTwentyEightDayGroutStrength({
                  value: values.floatValue,
                  unit: unitType,
                })
              );
            }
          }}
        />
      }
      unitValue={<ConvertUnit Metric={metricUnit} Imperial={imperialUnit} />}
    />
  );
}

export default TwentyEightDayGroutStrength;
